/** Cross-tab / same-tab cart change signal for checkout refresh. */
export const CART_SYNC_KEY = "mailarti-cart-updated";
export const CART_SYNC_EVENT = "mailarti-cart-updated";

export function notifyCartChanged() {
  const ts = String(Date.now());
  try {
    localStorage.setItem(CART_SYNC_KEY, ts);
  } catch (_) {
    /* private mode / quota — still fire in-tab event */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(CART_SYNC_EVENT, { detail: ts }));
  }
}

export function subscribeCartChanged(handler) {
  if (typeof window === "undefined") return () => {};

  const onStorage = (event) => {
    if (event.key === CART_SYNC_KEY && event.newValue) {
      handler(event.newValue);
    }
  };
  const onCustom = (event) => {
    handler(event.detail);
  };

  window.addEventListener("storage", onStorage);
  window.addEventListener(CART_SYNC_EVENT, onCustom);
  return () => {
    window.removeEventListener("storage", onStorage);
    window.removeEventListener(CART_SYNC_EVENT, onCustom);
  };
}
